import { render } from "./OwnerAddUpdateModal.vue?vue&type=template&id=ccbc5544"
import script from "./OwnerAddUpdateModal.vue?vue&type=script&lang=js"
export * from "./OwnerAddUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__